import { managerV1BaseUrl } from '@/utils';
import { Button } from '@e2n/ui/v2';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';

export function NavigationBackToV1({ name }: { name: string }) {
  const { id } = useParams();

  const urlBackToV1 = `${managerV1BaseUrl}/secure/mitarbeiter/detail.jsf?idMitarbeiter=${id}`;
  return (
    <div className="text-brand-blue-100 flex">
      <Button variant="ghost-on-grey" className="px-4" asChild>
        <a href={urlBackToV1} className="flex items-center gap-1">
          <FontAwesomeIcon icon={faArrowLeft} className="size-4" />
          <div className="font-semibold text-sm">{name}</div>
        </a>
      </Button>
    </div>
  );
}
